import React, { useState, useEffect } from "react";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

const TermsMobile = ({ tabList }) => {
  // const classes = useStyles();
  const [title, setTitle] = useState(0);
  const [content, setContent] = useState();

  const handleChange = (event, newValue) => {
    setTitle(newValue);
    setContent(tabList[newValue].content);
  };

  useEffect(() => {
    if (tabList && tabList.length > 0) {
      setTitle(0);
      setContent(tabList[0].content);
    }
  }, [tabList]);

  return (
    <div className="page-content w-full pb-36">
      <div className="w-full flex justify-end">
        <div className="w-full mb-5">
          <FormControl variant="outlined" className="w-full search-input">
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              onChange={handleChange}
              displayEmpty
              value={title}
            >
              {tabList
                ? tabList.map((m, index) => (
                    <MenuItem value={index} key={index}>
                      {m.title}
                    </MenuItem>
                  ))
                : ""}
            </Select>
          </FormControl>
        </div>
      </div>
      <div>{content}</div>
    </div>
  );
};

export default TermsMobile;
